import React from 'react';
import { Helmet } from 'react-helmet-async';

// @mui
import { styled } from '@mui/material/styles';
import { Typography, Box, Button } from '@mui/material';

import pageTitle from "../utils/pageTitles.json";
import { BlankCard } from '../components/cards/blankCard';
import KycTitleIcon from '../assets/svgs/kycTitleIcon';
import { useNavigate } from 'react-router-dom';
import Iconify from 'src/components/iconify';
import CampaignIcon from '@mui/icons-material/Campaign';
import { TemplateTable } from 'src/sections/sms/template/templatetable';
import { SenderIDTable } from 'src/sections/sms/senderIDList /SenderIDTable';

// home main section container.
const MainSection = styled('div')(({ theme }) => ({
    padding: "64px 20px 0px 88px",
    backgroundColor: "rgb(240, 240, 240)"/* theme.palette.background.default */,
    height: 'calc(100vh - 0px)',
    overflow: 'hidden'
}));

// Show home hading and filtes
const HeadingSection = styled('div')(() => ({
    width: '100%',
    padding: "20px 0px 20px 0px",
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row'
}));

const DetailsListSection = styled('div')(() => ({
    width: '100%',
    height: 'calc(100vh - 155px)',//'554px',
    overflow: 'hidden',
    overflowY: "scroll",
}));



const SmsSenderID = () => {

    const ttsTemplateList = (
        <Box sx={{ width: '100%' }}>
            <DetailsListSection className='reportListScroll'>
                <SenderIDTable />
            </DetailsListSection>
        </Box>
    )

    return (
        <>
            <Helmet>
                <title> {`${pageTitle?.smsSenderID}`} </title>
            </Helmet>

            <MainSection>

                {/* Heading and filters */}
                <HeadingSection>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '10px',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <Box sx={{
                            widht: '16px',
                            height: '16px',
                            mt: -1.8
                        }}>
                            <KycTitleIcon />
                        </Box>
                        <Typography variant='h5' sx={{ color: 'grey.10', fontWeight: 600 }}>
                            Sender ID List
                        </Typography>
                    </Box>
                </HeadingSection>

                <BlankCard
                    key="1"
                    sx={{
                        height: '100%',
                        width: '100%',
                        padding: '0px',
                        overflow: 'hidden',
                    }}
                >
                    {ttsTemplateList}
                </BlankCard>

            </MainSection>

        </>
    )
}

export default SmsSenderID;
